module.exports = __webpack_public_path__ + "static/img/banner_solutions_key.6c8bbb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/solution/banner_solutions_key.png
// module id = U3f2
// module chunks = 10